import { Pipe, PipeTransform } from '@angular/core';
import { PlatformIconService } from '@app/_shared/service/platform-icon.service';
import { IntegrationPlatform } from '@app/onboarding/store/integrations.service';

@Pipe({
  name: 'filterSalesChannel',
  standalone: false, // eslint-disable-line
})
export class FilterSalesChannelPipe implements PipeTransform {
  private platformIconService: PlatformIconService = new PlatformIconService();
  transform(salesChannels: Array<IntegrationPlatform>, showDeprecated: boolean = false): Array<IntegrationPlatform> {
    return salesChannels.filter(
      (platform) => showDeprecated || !this.platformIconService.deprecatedPlatforms().includes(platform),
    );
  }
}
